// extracted by mini-css-extract-plugin
module.exports = {"container":"NewReleaseModal_container__3cY0T","link":"NewReleaseModal_link__tWgia","buttonWrapper":"NewReleaseModal_buttonWrapper__19hdc"};